import { CreditorsService } from './source/creditorsSource';
import { LoginService } from './source/loginSource';
import { AdminService } from './source/adminSource';
import {
  RequestFieldsService,
  OutgoingRequestFieldsService,
} from './source/requestFieldsSource';
import { TicketsProvider, TicketsService } from './source/ticketsSource';
import { ReportService } from './source/reportSource';
import { SepaCountries } from './source/sepaCountries.factory';
import { PADContactService } from './source/padContactSource';

/**
 * Collect all data sources and export their services.
 */
export {
  CreditorsService,
  LoginService,
  AdminService,
  RequestFieldsService,
  OutgoingRequestFieldsService,
  TicketsProvider,
  TicketsService,
  ReportService,
  SepaCountries,
  PADContactService,
};
